<template>
    <div class="position-fixed ldc-model-mobile" v-if="$detect == 'mobile'" v-show="active">
        <div :class="{
                'ldc-content-mobile position-fixed w-100': true,
                'px-2 content-ios': !$isAndroid
            }" v-click-outside="outSide">
           
            <div :class="{
                'ldc-model-main bg-white w-100': true,
                'ldc-model-main-ios': !$isAndroid,
                '': $isAndroid,
            }">
                 <div :class="{
                        'ldc-title-model fs-16px px-3': true,
                        'text-center title-ios': !$isAndroid,
                        'title-android px-3': $isAndroid,
                    }" v-if="showTitle">
                    {{title}}
                </div>
                <div :class="{
                        'content-main': true,
                        'text-center slot-ios': !$isAndroid,
                        'slot-android': $isAndroid,
                    }">
                    <slot name="content-model"/>
                </div>
                <div class="custom-button" v-if="customButton && $isAndroid">
                    <slot name="custom-button"/>
                </div>
                <div class="cancel-android px-3" v-if="showCancel && $isAndroid"
                    @click="cancel()">
                    {{titileCancel}}
                </div>
            </div>
            <div class="custom-button mt-10px" v-if="customButton && !$isAndroid">
                <slot name="custom-button"/>
            </div>
            <slot name="custom-buttom"/>
            <div class="cancel-ios text-center my-10px" v-if="showCancel && !$isAndroid"
                @click="cancel()">
                {{titileCancel}}
            </div>
        </div>
    </div>
</template>
<script>
import { animationBlockModel, animationNoneModel } from './animation';
export default {
    props: {
        title: {
            type: String,
            default: 'Tiêu đề model'
        },
        showCancel: {
            type: Boolean,
            default: true,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        titileCancel: {
            type: String,
            default: 'Cancel'
        },
        visible: {
            type: Boolean,
            default: false,
        },
        customButton: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        visible(val){
            this.active = val;
        },
        active(val){
            this.$emit('update:visible', val);
            if(val){
                setTimeout(() => {
                    this.setMaxHeight();
                }, 0)
                animationBlockModel(this.$el);
                this.$overflowHidenBody();
            }else{
                this.$removeOverflowHidenBody();
            }
        }
    },
    data() {
        return {
            active: false,
        }
    },
    created(){
        if(this.$delete == 'web'){
            console.error('component ldc-model-mobile chỉ hoạt động trên mobile');
        }
    },
    mounted(){
        let dom = this.$el.querySelectorAll('[close-model-mobile]');
        for(let i = 0; i < dom.length; i++){
            dom[i].onclick = () => {
                this.cancel();
            }
        }
    },
    methods: {
        outSide(e){
            if(e.target == this.$el){
                this.cancel();
            }
        },
        cancel(){
            animationNoneModel(this.$el, (data) => {
                this.active = false;
            })
        },
        setMaxHeight(){
            let height = window.visualViewport ? window.visualViewport.height * 0.95 : window.innerHeight * 0.95;
            let el = this.$el;
            let content = el.querySelector('.ldc-content-mobile');
            content.style.maxHeight = height + 'px';

            let main = el.querySelector('.content-main');
            if(this.$isAndroid){
                let cancel = el.querySelector('.cancel-android');
                if(cancel){
                    cancel = cancel.offsetHeight;
                }else{
                    cancel = 0;
                }
                let title = el.querySelector('.ldc-title-model');
                if(title){
                    title = title.offsetHeight;
                }else{
                    title = 0;
                }
                let customButton = el.querySelector('.custom-button');
                if(customButton){
                    customButton = customButton.offsetHeight
                }else{
                    customButton = 0;
                }
                main.style.maxHeight = height - cancel - title - customButton + 'px';
            }else{
                let cancel = el.querySelector('.cancel-ios');
                if(cancel){
                    cancel = cancel.offsetHeight + 20;
                }else{
                    cancel = 0;
                }
                let title = el.querySelector('.ldc-title-model');
                if(title){
                    title = title.offsetHeight;
                }else{
                    title = 0;
                }
                let customButton = el.querySelector('.custom-button');
                if(customButton){
                    customButton = customButton.offsetHeight + 10
                }else{
                    customButton = 0;
                }
                main.style.maxHeight = height - cancel - title + 'px';
            }
        }
    }
}
</script>
